<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="ma-0 pa-0 text-center">
            <label class="font-weight-black blue--text text--darken-4 title">Select button below to view IC's</label>

            <div class="mt-10">
              <v-btn color="blue darken-4" dark width="175" :to="`/iclistselector/iclistby/zone/`">Zone</v-btn><br><br>
              <v-btn color="blue darken-4" dark width="175" :to="`/iclistselector/iclistby/name/last/`">Last Name</v-btn><br><br>
              <v-btn color="blue darken-4" dark width="175" :to="`/iclistselector/iclistby/type/`">Type</v-btn>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ICListSelector',
    data () {
      return {
        search: '',
      }
    },
    mounted() {
      this.setBackButtonVisibility(true);
      this.setHomeButtonVisibility(true);
    }
  }
</script>

<style scoped>

</style>
